var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentName,{tag:"component",attrs:{"block":_vm.block}})
}
var staticRenderFns = []

export { render, staticRenderFns }